import { makeStyles } from '@material-ui/core'
import themesConfig from 'app/fuse-configs/themesConfig'

export default makeStyles(() => ({
  buttonWrap: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  button: {
    padding: 0,
  },

  actionMenu: {
    marginTop: 5,

    '& .MuiList-padding': {
      padding: 0,
    },
  },

  menuOption: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '6px 10px',
  },

  editOption: {
    backgroundColor: 'transparent',
    color: themesConfig.default.colors.primary,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  deleteOption: {
    backgroundColor: themesConfig.default.colors['red-50'],
    color: themesConfig.default.colors['red-600'],
    '&:hover': {
      backgroundColor: themesConfig.default.colors['red-50'],
    },
  },
}))
